export default __webpack_public_path__ + "static/media/Logo-Leader-Park.6ecb764d.png";